<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
    v-col.py-0.text-right
      v-btn.mr-2(color="white", @click="save", :disabled="loading") {{ $t('Common.save') }}
  v-row(v-if="!loading")
    v-col.py-0
      v-card.elevation-24.mb-5
        app-full-entity(:entity="entity", :ignoreTabs="ignoreTabsAT", v-bind="{ customLabel }")
          template(v-slot:ActionTemplate="props")
            action-template-general(@input="changeAction", :slotProps="props", v-bind="{ errors, loading, uid }")
            template(v-for="section in (props.sections || []).filter(x => x.section === entity.name || x.section === entity.tabLabel)")
              app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)")
          template(v-slot:triggerActions="props")
            email-template(
              v-model="instance.content",
              v-if="action.name != null && (action.name.startsWith(SEND_EMAIL))",
              :attachReport="action.name === SEND_EMAIL_WITH_REPORT",
            )
            edi-template(
              v-else-if="action.name != null && (action.name.startsWith(SEND_GEOBUS_HTTP_REQUEST))",
              v-model="instance.content",
            )
            edi-generic-template(
              v-else-if="action.name != null && (action.name.startsWith(SEND_GENERIC_HTTP_REQUEST))",
              v-model="instance.content",
            )
            execute-script-template(
              v-else-if="action.name != null && (action.name.startsWith(EXECUTE_SCRIPT))",
              v-model="instance.content",
            )
            create-file-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(CREATE_PDF))",
            )
            generate-quote-form-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(EXTERNAL_FORM))",
            )
            generate-data-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(GENERATE_DATA))",
            )
            generate-custom-logs-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(GENERATE_CUSTOM_LOGS))",
            )
            data-integration-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(DATA_INTEGRATION))",
            )
            attach-to-document-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(CALL_LABELS_MICRO_SERVICE))",
            )
            create-text-file-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(CREATE_TEXT_FILE))",
            )
            schedule-action-template(
              v-model="instance.content",
              v-else-if="action.name != null && (action.name.startsWith(SCHEDULE_ACTION))",
            )
            change-status-template(v-else, v-model="instance.content")
          template(v-slot:eDILogs="props")
            simulation
</template>

<script>
import axios from "axios";
import ActionTemplateGeneral from '@/components/ActionTemplate/General';
import ChangeStatusTemplate from '@/components/ActionTemplate/ChangeStatusTemplate';
import EmailTemplate from '@/components/ActionTemplate/EmailTemplate';
import EdiTemplate from '@/components/ActionTemplate/EdiTemplate';
import EdiGenericTemplate from '@/components/ActionTemplate/EdiGenericTemplate';
import CreateFileTemplate from '@/components/ActionTemplate/CreateFileTemplate';
import GenerateDataTemplate from '@/components/ActionTemplate/GenerateDataTemplate';
import GenerateCustomLogsTemplate from '@/components/ActionTemplate/GenerateCustomLogsTemplate';
import GenerateQuoteFormTemplate from '@/components/ActionTemplate/ExternalFormTemplate';
import AttachToDocumentTemplate from '@/components/ActionTemplate/AttachToDocumentTemplate';
import CreateTextFileTemplate from '@/components/ActionTemplate/CreateTextFileTemplate';
import DataIntegrationTemplate from '@/components/ActionTemplate/DataIntegrationTemplate';
import ExecuteScriptTemplate from '@/components/ActionTemplate/ExecuteScriptTemplate';
import Simulation from '@/components/ActionTemplate/Simulation';
import ScheduleActionTemplate from '@/components/ActionTemplate/ScheduleActionTemplate';
import EntityMixin from '@/mixins';
import { 
  SEND_EMAIL, 
  SEND_EMAIL_WITH_REPORT, 
  SEND_GEOBUS_HTTP_REQUEST, 
  SEND_GENERIC_HTTP_REQUEST,
  CHANGE_STATUS_TO_ENTITY, 
  CREATE_PDF, 
  EXTERNAL_FORM, 
  GENERATE_DATA, 
  GENERATE_CUSTOM_LOGS, 
  DATA_INTEGRATION, 
  CALL_LABELS_MICRO_SERVICE, 
  CREATE_TEXT_FILE, 
  EXECUTE_SCRIPT,
  SCHEDULE_ACTION
} from '@/components/ActionTemplate/constants.js';

export default {
  name: "ActionTemplateAdd",
  components: {
    ActionTemplateGeneral,
    ChangeStatusTemplate,
    EmailTemplate,
    CreateFileTemplate,
    GenerateDataTemplate,
    GenerateCustomLogsTemplate,
    GenerateQuoteFormTemplate,
    DataIntegrationTemplate,
    EdiTemplate,
    EdiGenericTemplate,
    AttachToDocumentTemplate,
    CreateTextFileTemplate,
    ExecuteScriptTemplate,
    Simulation,
    ScheduleActionTemplate
  },
  mixins: [EntityMixin],
  data() {
    return {
      Headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
      ],
      action: {},
      originalInstance: null,
      originalAction: null,
      // actions: [],
      loading: true,
      // instance: {
      //   scheduledActionTemplate: [],
      // },
      errors: {},
      permIgnore: [
        "iScope",
        "action",
        "scheduledActionTemplate",
      ],
      onAddIgnore: ["history"],
      actionTemplateName: "email",

      // Render needs to see them on this
      SEND_EMAIL,
      SEND_EMAIL_WITH_REPORT,
      SEND_GEOBUS_HTTP_REQUEST,
      SEND_GENERIC_HTTP_REQUEST,
      CREATE_PDF,
      EXTERNAL_FORM,
      GENERATE_DATA,
      GENERATE_CUSTOM_LOGS,
      DATA_INTEGRATION,
      CHANGE_STATUS_TO_ENTITY,
      CALL_LABELS_MICRO_SERVICE,
      CREATE_TEXT_FILE,
      EXECUTE_SCRIPT,
      SCHEDULE_ACTION
    };
  },
  computed: {
    entityName() {
      return "ActionTemplate";
    },
    entity() {
      return this.$findEntity("ActionTemplate");
    },
    uid() {
      return this.$route.params.item;
    },
    ignoreTabsAT() {
      return [
        ...this.permIgnore,
        ...(_.get(this.instance, 'actionId') ? [] : ['triggerActions']),
        ...(this.uid ? [] : this.onAddIgnore),
        ...(this.uid && this.hasSimulation ? [] : ['eDILogs']),
      ];
    },
    hasSimulation() {
      let actionName = _.get(this.action, 'name');
      return [
        SEND_EMAIL, 
        SEND_EMAIL_WITH_REPORT, 
        SEND_GEOBUS_HTTP_REQUEST, 
        SEND_GENERIC_HTTP_REQUEST, 
        CREATE_PDF, 
        EXTERNAL_FORM, 
        GENERATE_DATA, 
        GENERATE_CUSTOM_LOGS, 
        DATA_INTEGRATION, 
        CREATE_TEXT_FILE, 
        EXECUTE_SCRIPT,
        SCHEDULE_ACTION
      ].includes(actionName);
    },
    customLabel() {
      return ({
        ActionTemplate: this.$t('Common.general'),
        triggerActions: this.$t('ActionTemplate.content'),
        eDILogs: this.$t('ActionTemplate.templateSimulation'),
      });
    },
  },
  methods: {
    changeAction(val) {
      this.action = val;
      this.restoreOriginalOrReset(val);
    },
    restoreOriginalOrReset(actionSelected) {
      if (!this.originalInstance) return;
      if (actionSelected.id == this.originalAction.id){
        if (this.action.name != SEND_GEOBUS_HTTP_REQUEST || this.action.name != SEND_GENERIC_HTTP_REQUEST)
          this.instance.content = JSON.parse(this.originalInstance.content);
        else
          this.instance.content = this.originalInstance.content;
      } else{
        this.instance.content = {};
      }
    },
    getTemplateType() {
      switch (this.action.name) {
        case this.SEND_MESSAGE_TO_GEOBUS:
        case this.SEND_GEOBUS_HTTP_REQUEST:
        case this.SEND_GENERIC_HTTP_REQUEST:
        case this.SEND_HTTP_REQUEST:
          return "EDI"
        case this.SEND_EMAIL:
        case this.SEND_EMAIL_WITH_REPORT:
          return "EMAIL"
        case this.CREATE_TEXT_FILE:
          return "TEXT_FILE"
        case this.CREATE_PDF:
          return "PDF"
        case this.EXTERNAL_FORM:
          return "EXTERNAL FORM"
        case this.GENERATE_DATA:
          return "GENERATE DATA"
        case this.GENERATE_CUSTOM_LOGS:
          return "GENERATE CUSTOM LOGS"
        case this.DATA_INTEGRATION:
          return "DATA INTEGRATION"
        case this.CHANGE_STATUS_TO_ENTITY:
          return "CHANGE STATUS"
        case this.CALL_LABELS_MICRO_SERVICE:
          return "CALL LABELING SERVICE"
        case this.EXECUTE_SCRIPT:
          return "EXECUTE SCRIPT"
        case this.SCHEDULE_ACTION:
          return "SCHEDULE_ACTION"
      }
    },
    async save() {
      try {
        let content = "";
        content = JSON.stringify(this.instance.content);
        const _template = {
          ...this.instance,
          templateType: this.getTemplateType(),
          businessScopeId: (this.instance.businessScope && this.instance.businessScope.id) != null ? this.instance.businessScope.id : window.localStorage.getItem("BusinessScopeId"),
          actionId: this.action.id,
          pendingTask: this.instance.content.pendingTask,
          content,
        };
        delete _template.action;
        if (!_template.id) {
          _template.entityState = 4;
        } else {
          _template.entityState = 3;
        }
        this.instance = (await axios.post("entity/graph", _template)).data;
        this.$router.push({
          name: "entities.index",
          params: { entity: this.entity.name },
        });
      } catch (error) {
        console.error(error);
      }
    },
    async load() {
      try {
        if (this.uid) {
          this.instance = (
            await axios.get(`${this.entity.name}/${this.uid}`, {
              params: {
                load: ["action"],
              },
            })
          ).data;
          this.action = this.instance.action;
          this.originalInstance = {...this.instance};
          this.originalAction = {...this.action};
          this.instance.content = JSON.parse(this.instance.content);
        }
        else{
          this.instance.content = {};
        }
      } catch (error) {
        if (!this.action.name == SEND_GEOBUS_HTTP_REQUEST)
          console.error("Error parsing action template content", error);
      }
      this.loading = false;
    },
    async getBusinessScope(businessScopeId){
      if(businessScopeId == null) return null;
      let bs = (await axios.get('BusinessScope?where[]=id=' + businessScopeId)).data.data;
      return bs[0];
    },
  },
  async created () {
    const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
    const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);

    const baseInstance = {
      entityState: 4,
      _Entity: this.entity.name,
      user: this.$store.state.user.user,
      businessScope: lsbusinessScope,
    }
    this.$store.commit('SET_INSTANCE', baseInstance);

    await this.load();
  }
};
</script>
